import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { parsePhoneNumberWithRemovePlus } from 'features/call/call-base/helpers';
import { updateCallRecord } from 'features/call/call-base/store/callSlice';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import { sanitizePhoneExtension } from 'features/call/call-hearing/helpers/sanitizePhoneExtension';
import {
  primaryHearingPhoneNumberSelector,
  primaryHearingSelector,
} from 'features/call/call-hearing/store';
import { isPrimaryVcoSenderSelector } from 'features/vco/store';

export const syncHearingPhoneExtensionToCallRecord = createAsyncThunk(
  'call/syncHearingPhoneExtensionToCallRecord',
  async (phoneNumber: string, { dispatch, getState }) => {
    const state = getState() as RootState;

    if (!isPrimaryVcoSenderSelector(state)) {
      return;
    }

    const callId = callIdSelector(state);
    if (!callId) {
      return;
    }

    const primaryHearingPhoneNumber = primaryHearingPhoneNumberSelector(state);
    if (
      parsePhoneNumberWithRemovePlus(phoneNumber) !==
      parsePhoneNumberWithRemovePlus(primaryHearingPhoneNumber)
    ) {
      return;
    }

    const hearingPhoneExtension = sanitizePhoneExtension(
      primaryHearingSelector(state).phoneExtension
    );

    if (hearingPhoneExtension === (state.call.hearingPhoneExtension ?? '')) {
      return;
    }

    await dispatch(
      updateCallRecord({ HearingPhoneExtension: hearingPhoneExtension })
    );
  }
);
